// @ts-nocheck
import type { Requests } from '../../../../base/realtime-session';
import type { FeatureFlagsPost } from '../../../../types/server/modules/featureFlags/post';

export type * from '../../../../types/server/modules/featureFlags/post';

export const createPost = ( requests: Requests ): FeatureFlagsPost => ({
  import_feature_flags: Object.assign(( body,headers ) => {
      return requests.post( `/feature-flags/import`, { body }, headers );
    }, { operation: 'feature-flags:import-feature-flags', route: 'POST /feature-flags/import', subdomain: 'feature-flags', visibility: 'private' } as const )
});
